$(function () {

    $(".more").each(function () {
        $(this).attr("data-original", $(this).text());
    });

    $(".more").on("click", function () {

        var $this = $(this);
        var $day = $this.closest(".day");
        var $extra = $day.find(".extra");

        if ($day.hasClass("active")) {

            $day.removeClass("active");
            $extra.stop().slideUp(300);
            $this.text($this.attr("data-original"));

        } else {

            $day.addClass("active");
            $extra.stop().slideDown(300);
            $this.text("Show Less");

        }

    });

});